import type { Placement } from '@floating-ui/core';
import { initTooltips } from 'flowbite';
import { useEffect, type FC } from 'react';
import { createPortal } from 'react-dom';
import { twMerge } from 'tailwind-merge';

const HoverTooltip: FC<{
  title: string;
  text: string;
  className?: string;
  placement: Placement;
}> = ({ title, text, className, placement }) => {
  useEffect(() => {
    initTooltips();

    return;
  }, []);

  return (
    <>
      <div
        data-tooltip-placement={placement}
        data-tooltip-target={`tab-tooltip-${title}`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4 text-gray-400"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            clipRule="evenodd"
          />
        </svg>
        <span className="sr-only">More info</span>
      </div>
      {createPortal(
        <div
          id={`tab-tooltip-${title}`}
          role="tooltip"
          className={twMerge(
            'tooltip invisible absolute mb-20 inline-block rounded-lg bg-gray-900 px-3 py-2 text-sm font-medium text-white shadow-sm dark:bg-gray-700 z-50',
            className
          )}
        >
          {text}
          <div className="tooltip-arrow" data-popper-arrow=""></div>
        </div>,
        document.body
      )}
    </>
  );
};

export default HoverTooltip;
